import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DecimalPipe } from '@angular/common';


import { environment } from '@teem/environments/environment';
import { TaxService } from '@teem/core/services/tax.service';
import { TeemappTableComponent } from '@teem/shared/index';
import { parseDate } from '@teem/helpers/functions';
import { ngDebounce } from '@teem/decorators/debouce.decorator';
import { SharedDataService } from '@teem/services/shared-data.service';

import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { InputTaxTableComponent } from '@teem/taxes-module/components/input-tax-table/input-tax-table.component';
import { OutputTaxTableSchema } from '@teem/taxes-module/classes/output-tax-table-schema';
import { AddExpenseComponent } from '@teem/taxes-module/modals/add-expense/add-expense.component';


declare var $;

@Component({
  selector: 'app-taxes',
  templateUrl: './taxes.component.html',
  styleUrls: ['./taxes.component.scss'],
  providers: [UserCurrencyPipe, DecimalPipe]
})

export class TaxesComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @ViewChild('taxesTableRef') taxesTableRef: TeemappTableComponent;
  @ViewChild('allInputTableRef') allInputTableRef: InputTaxTableComponent;

  taxesTable: OutputTaxTableSchema = new OutputTaxTableSchema(this);
  userInfo:any;
  all_input: number = 0;
  all_output: number = 0;
  outputTaxCount: number = 0;
  inputTaxCount: number = 0;
  activeTab: string = 'input-tab';
  isSearch: boolean = false;
  isFilter: boolean = false;
  fromDate: any = '';
  toDate: any = '';
  toStatus: any;
  minAmount: any = '';
  maxAmount: any = '';
  params: any = {};

  constructor(
    private modalService: NgbModal,
    private taxService: TaxService,
    private decimalPipe: DecimalPipe,
    private currencyPipe: UserCurrencyPipe,
    private sharedDataService: SharedDataService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.taxService.commonData().subscribe((data: any) => {
      this.all_input = data.all_input_tax;
      this.all_output = data.all_output_tax;
    })

    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.userInfo = data.userInfo;
      }
    })
  }

  onLoadOutputTaxes(data: any) {
    this.outputTaxCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  toggleFilter() {
    this.isFilter = !this.isFilter;
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    // this.filterTaxes();
    this.resetStatusFilters();

    this.toStatus = "";
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  filterByDate() {
    if (this.fromDate) {
      this.params.from_date = this.fromDate; //parseDate(this.fromDate);
    }
    if (this.toDate) {
      this.params.to_date = this.toDate; // parseDate(this.toDate);
    }

    if (!(this.params.from_date || this.params.to_date)) {
      this.allInputTableRef.resetDateFilters();
      this.taxesTableRef.resetDateFilters();

      this.allInputTableRef.getPage(1);
      this.taxesTableRef.getPage(1);
    } else if (this.params.from_date && this.params.to_date) {

      if (this.activeTab == 'input-tab')
        this.allInputTableRef.getPage(1, false, this.params);
      else if (this.activeTab == 'output-tab')
        this.taxesTableRef.getPage(1, false, this.params);
    }
  }

  // function called after 2s
  @ngDebounce(500)
  filterByAmount() {
    // if(this.minAmount) {
      this.params.min_amount = this.minAmount;
    // }

    // if(this.maxAmount) {
      this.params.max_amount = this.maxAmount; 
    // }

    // if (this.params.min_amount || this.params.max_amount) {
      if (this.activeTab == 'input-tab')
        this.allInputTableRef.getPage(1, false, this.params);
      else if (this.activeTab == 'output-tab')
        this.taxesTableRef.getPage(1, false, this.params);
    // }
  }

  resetDateFilters() {
    if (this.fromDate || this.toDate) {
      this.fromDate = "";
      this.toDate = "";
      this.filterByDate();
    }
  }

  resetAmountFilters() {
    if(this.minAmount || this.maxAmount) {
      this.minAmount = "";
      this.maxAmount = "";
      this.filterByAmount();
    }
  }

  resetStatusFilters() {
    if(this.toStatus) {
      this.toStatus = "";
      if (!(this.toStatus)) {
        this.allInputTableRef.timeFilter = this.toStatus;
        this.allInputTableRef.getPage(1);
        this.taxesTableRef.getPage(1);
      }
    }
  }

  onLoadInputTaxes(data: any) {
    this.inputTaxCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  switchTab(tab: string) {
    this.activeTab = tab;
  }

  clearAllFilter() {
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetStatusFilters();
    this.toStatus = "";
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;

    if (this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.searchTaxes("");
    }
  }

  onDateIconClick(event: Event, field: string): void {
    const target = event.target as HTMLElement;
    const wrapper = target.closest('.date-input-wrap');
    const input = wrapper?.querySelector('input[date-dropper]') as HTMLInputElement;
    
    const rect = wrapper?.getBoundingClientRect();
    const clickX = (event as MouseEvent).clientX;
    const iconArea = rect!.right - 30;
    
    if (clickX >= iconArea && input) {
      input.click();
    }
  }

  filterTaxes() {
    //if (this.activeTab == 'input-tab') {
    this.allInputTableRef.timeFilter = this.toStatus;
    this.params.filter_by = this.toStatus
    this.taxesTableRef.getPage(1, false, this.params);
    this.allInputTableRef.getPage(1, false, this.params);
    // } else if (this.activeTab == 'output-tab') {
    //}
  }

  searchTaxes(term: string) {
    if (this.activeTab == 'input-tab') {
      this.allInputTableRef.search.next(term);
    } else if (this.activeTab == 'output-tab') {
      this.taxesTableRef.search.next(term);
    }
  }

  openAddTaxModal() {
    const modalRef = this.modalService.open(AddExpenseComponent);
    // // Set id on modal dialog
    // modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "taxdetails";

    const parentNode = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode;
    const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.parentElement;
    parentNode.classList.add( "taxdetails");
    parentElement.classList.add( "taxes");

    modalRef.result.then(result => {
      this.activeTab == 'input-tab';
      this.allInputTableRef.getPage(1, false);
    }, fallbackResult => {
    })
  }


  exportXls() {
    if (this.activeTab == 'input-tab') {
      (window as any).open(`${environment.baseUrl}/taxes/download?from=${this.fromDate}&to=${this.toDate}&type=input-tax`, '_self', 'location=yes');
    } else if (this.activeTab == 'output-tab') {
      (window as any).open(`${environment.baseUrl}/taxes/download?from=${this.fromDate}&to=${this.toDate}&type=output-tax`, '_self', 'location=yes');
    }
  }

   onChangePerPageItems(page: any) {
    if (page?.limit) {
      this.params.limit = page?.limit;
      this.allInputTableRef.getPage(1, false, this.params);
    }
  }
}
